export const LOGIN_USER_REQUEST = "LOGIN_USER_REQUEST";
export const LOGIN_USER_FAILURE = "LOGIN_USER_FAILURE";
export const LOGIN_USER_SUCCESS = "LOGIN_USER_SUCCESS";
export const LOGOUT_USER = "LOGOUT_USER";
export const FORCE_AUTH_RECHECK = "FORCE_AUTH_RECHECK";

export const USER_CREATE_REQUEST = "USER_CREATE_REQUEST";
export const USER_CREATE_SUCCESS = "USER_CREATE_SUCCESS";
export const USER_CREATE_FAILURE = "USER_CREATE_FAILURE";
export const USER_GET_REQUEST = "USER_GET_REQUEST";
export const USER_GET_SUCCESS = "USER_GET_SUCCESS";
export const USER_GET_FAILURE = "USER_GET_FAILURE";
export const USER_UPDATE_REQUEST = "USER_UPDATE_REQUEST";
export const USER_UPDATE_SUCCESS = "USER_UPDATE_SUCCESS";
export const USER_UPDATE_FAILURE = "USER_UPDATE_FAILURE";
export const USER_PROFILE_GET_REQUEST = "USER_PROFILE_GET_REQUEST";
export const USER_PROFILE_GET_SUCCESS = "USER_PROFILE_GET_SUCCESS";
export const USER_PROFILE_GET_FAILURE = "USER_PROFILE_GET_FAILURE";
export const USER_PROFILE_UPDATE_REQUEST = "USER_PROFILE_UPDATE_REQUEST";
export const USER_PROFILE_UPDATE_SUCCESS = "USER_PROFILE_UPDATE_SUCCESS";
export const USER_PROFILE_UPDATE_FAILURE = "USER_PROFILE_UPDATE_FAILURE";
export const USER_CHANGE_PASSWORD_REQUEST = "USER_CHANGE_PASSWORD_REQUEST";
export const USER_CHANGE_PASSWORD_SUCCESS = "USER_CHANGE_PASSWORD_SUCCESS";
export const USER_CHANGE_PASSWORD_FAILURE = "USER_CHANGE_PASSWORD_FAILURE";
export const USER_RESET_PASSWORD_REQUEST = "USER_RESET_PASSWORD_REQUEST";
export const USER_RESET_PASSWORD_SUCCESS = "USER_RESET_PASSWORD_SUCCESS";
export const USER_RESET_PASSWORD_FAILURE = "USER_RESET_PASSWORD_FAILURE";

export const ADMIN_GET_BASICS_REQUEST = "ADMIN_GET_BASICS_REQUEST";
export const ADMIN_GET_BASICS_SUCCESS = "ADMIN_GET_BASICS_SUCCESS";
export const ADMIN_GET_BASICS_FAILURE = "ADMIN_GET_BASICS_FAILURE";

export const ADMIN_GET_SECTIONS_REQUEST = "ADMIN_GET_SECTIONS_REQUEST";
export const ADMIN_GET_SECTIONS_SUCCESS = "ADMIN_GET_SECTIONS_SUCCESS";
export const ADMIN_GET_SECTIONS_FAILURE = "ADMIN_GET_SECTIONS_FAILURE";
export const ADMIN_GET_SECTION_REQUEST = "ADMIN_GET_SECTION_REQUEST";
export const ADMIN_GET_SECTION_SUCCESS = "ADMIN_GET_SECTION_SUCCESS";
export const ADMIN_GET_SECTION_FAILURE = "ADMIN_GET_SECTION_FAILURE";
export const ADMIN_UPDATE_SECTION_REQUEST = "ADMIN_UPDATE_SECTION_REQUEST";
export const ADMIN_UPDATE_SECTION_SUCCESS = "ADMIN_UPDATE_SECTION_SUCCESS";
export const ADMIN_UPDATE_SECTION_FAILURE = "ADMIN_UPDATE_SECTION_FAILURE";
export const ADMIN_DELETE_SECTION_REQUEST = "ADMIN_DELETE_SECTION_REQUEST";
export const ADMIN_DELETE_SECTION_SUCCESS = "ADMIN_DELETE_SECTION_SUCCESS";
export const ADMIN_DELETE_SECTION_FAILURE = "ADMIN_DELETE_SECTION_FAILURE";
export const ADMIN_CREATE_SECTION_REQUEST = "ADMIN_CREATE_SECTION_REQUEST";
export const ADMIN_CREATE_SECTION_SUCCESS = "ADMIN_CREATE_SECTION_SUCCESS";
export const ADMIN_CREATE_SECTION_FAILURE = "ADMIN_CREATE_SECTION_FAILURE";
export const ADMIN_UPDATE_GENERAL_REQUEST = "ADMIN_UPDATE_GENERAL_REQUEST";
export const ADMIN_UPDATE_GENERAL_SUCCESS = "ADMIN_UPDATE_GENERAL_SUCCESS";
export const ADMIN_UPDATE_GENERAL_FAILURE = "ADMIN_UPDATE_GENERAL_FAILURE";
export const ADMIN_GET_GENERAL_REQUEST = "ADMIN_GET_GENERAL_REQUEST";
export const ADMIN_GET_GENERAL_SUCCESS = "ADMIN_GET_GENERAL_SUCCESS";
export const ADMIN_GET_GENERAL_FAILURE = "ADMIN_GET_GENERAL_FAILURE";

export const ADMIN_CREATE_DEPOSIT_REQUEST = "ADMIN_GET_GENERAL_REQUEST";
export const ADMIN_CREATE_DEPOSIT_SUCCESS = "ADMIN_CREATE_DEPOSIT_SUCCESS";
export const ADMIN_CREATE_DEPOSIT_FAILURE = "ADMIN_CREATE_DEPOSIT_FAILURE";

export const ADMIN_UPDATE_DEPOSIT_REQUEST = "ADMIN_UPDATE_DEPOSIT_REQUEST";
export const ADMIN_UPDATE_DEPOSIT_SUCCESS = "ADMIN_UPDATE_DEPOSIT_SUCCESS";
export const ADMIN_UPDATE_DEPOSIT_FAILURE = "ADMIN_UPDATE_DEPOSIT_FAILURE";

export const ADMIN_CREATE_MARKING_REQUEST = "ADMIN_GET_MARKING_REQUEST";
export const ADMIN_CREATE_MARKING_SUCCESS = "ADMIN_CREATE_MARKING_SUCCESS";
export const ADMIN_CREATE_MARKING_FAILURE = "ADMIN_CREATE_MARKING_FAILURE";

export const ADMIN_UPDATE_MARKING_REQUEST = "ADMIN_UPDATE_MARKING_REQUEST";
export const ADMIN_UPDATE_MARKING_SUCCESS = "ADMIN_UPDATE_MARKING_SUCCESS";
export const ADMIN_UPDATE_MARKING_FAILURE = "ADMIN_UPDATE_MARKING_FAILURE";

export const ADMIN_GET_SECTION_PRIZE_REQUEST = "ADMIN_GET_SECTION_PRIZE_REQUEST";
export const ADMIN_GET_SECTION_PRIZE_SUCCESS = "ADMIN_GET_SECTION_PRIZE_SUCCESS";
export const ADMIN_GET_SECTION_PRIZE_FAILURE = "ADMIN_GET_SECTION_PRIZE_FAILURE";
export const ADMIN_CREATE_SECTION_PRIZE_REQUEST = "ADMIN_CREATE_SECTION_PRIZE_REQUEST";
export const ADMIN_CREATE_SECTION_PRIZE_SUCCESS = "ADMIN_CREATE_SECTION_PRIZE_SUCCESS";
export const ADMIN_CREATE_SECTION_PRIZE_FAILURE = "ADMIN_CREATE_SECTION_PRIZE_FAILURE";
export const ADMIN_UPDATE_SECTION_PRIZE_REQUEST = "ADMIN_UPDATE_SECTION_PRIZE_REQUEST";
export const ADMIN_UPDATE_SECTION_PRIZE_SUCCESS = "ADMIN_UPDATE_SECTION_PRIZE_SUCCESS";
export const ADMIN_UPDATE_SECTION_PRIZE_FAILURE = "ADMIN_UPDATE_SECTION_PRIZE_FAILURE";
export const ADMIN_DELETE_SECTION_PRIZE_REQUEST = "ADMIN_DELETE_SECTION_PRIZE_REQUEST";
export const ADMIN_DELETE_SECTION_PRIZE_SUCCESS = "ADMIN_DELETE_SECTION_PRIZE_SUCCESS";
export const ADMIN_DELETE_SECTION_PRIZE_FAILURE = "ADMIN_DELETE_SECTION_PRIZE_FAILURE";

export const ADMIN_GET_CLUBS_REQUEST = "ADMIN_GET_CLUBS_REQUEST";
export const ADMIN_GET_CLUBS_SUCCESS = "ADMIN_GET_CLUBS_SUCCESS";
export const ADMIN_GET_CLUBS_FAILURE = "ADMIN_GET_CLUBS_FAILURE";
export const ADMIN_GET_CLUB_REQUEST = "ADMIN_GET_CLUB_REQUEST";
export const ADMIN_GET_CLUB_SUCCESS = "ADMIN_GET_CLUB_SUCCESS";
export const ADMIN_GET_CLUB_FAILURE = "ADMIN_GET_CLUB_FAILURE";
export const ADMIN_GET_MEMBERS_REQUEST = "ADMIN_GET_MEMBERS_REQUEST";
export const ADMIN_GET_MEMBERS_SUCCESS = "ADMIN_GET_MEMBERS_SUCCESS";
export const ADMIN_GET_MEMBERS_FAILURE = "ADMIN_GET_MEMBERS_FAILURE";
export const ADMIN_GET_MEMBER_REQUEST = "ADMIN_GET_MEMBER_REQUEST";
export const ADMIN_GET_MEMBER_SUCCESS = "ADMIN_GET_MEMBER_SUCCESS";
export const ADMIN_GET_MEMBER_FAILURE = "ADMIN_GET_MEMBER_FAILURE";
export const ADMIN_GET_PIGEON_HOLE_REQUEST = "ADMIN_GET_PIGEON_HOLE_REQUEST";
export const ADMIN_GET_PIGEON_HOLE_SUCCESS = "ADMIN_GET_PIGEON_HOLE_SUCCESS";
export const ADMIN_GET_PIGEON_HOLE_FAILURE = "ADMIN_GET_PIGEON_HOLE_FAILURE";
export const ADMIN_CREATE_CLUB_REQUEST = "ADMIN_CREATE_CLUB_REQUEST";
export const ADMIN_CREATE_CLUB_SUCCESS = "ADMIN_CREATE_CLUB_SUCCESS";
export const ADMIN_CREATE_CLUB_FAILURE = "ADMIN_CREATE_CLUB_FAILURE";
export const ADMIN_UPDATE_CLUB_REQUEST = "ADMIN_UPDATE_CLUB_REQUEST";
export const ADMIN_UPDATE_CLUB_SUCCESS = "ADMIN_UPDATE_CLUB_SUCCESS";
export const ADMIN_UPDATE_CLUB_FAILURE = "ADMIN_UPDATE_CLUB_FAILURE";
export const ADMIN_DELETE_CLUB_REQUEST = "ADMIN_DELETE_CLUB_REQUEST";
export const ADMIN_DELETE_CLUB_SUCCESS = "ADMIN_DELETE_CLUB_SUCCESS";
export const ADMIN_DELETE_CLUB_FAILURE = "ADMIN_DELETE_CLUB_FAILURE";
export const ADMIN_CREATE_MEMBER_REQUEST = "ADMIN_CREATE_MEMBER_REQUEST";
export const ADMIN_CREATE_MEMBER_SUCCESS = "ADMIN_CREATE_MEMBER_SUCCESS";
export const ADMIN_CREATE_MEMBER_FAILURE = "ADMIN_CREATE_MEMBER_FAILURE";
export const ADMIN_UPDATE_MEMBER_REQUEST = "ADMIN_UPDATE_MEMBER_REQUEST";
export const ADMIN_UPDATE_MEMBER_SUCCESS = "ADMIN_UPDATE_MEMBER_SUCCESS";
export const ADMIN_UPDATE_MEMBER_FAILURE = "ADMIN_UPDATE_MEMBER_FAILURE";
export const ADMIN_DELETE_MEMBER_REQUEST = "ADMIN_DELETE_MEMBER_REQUEST";
export const ADMIN_DELETE_MEMBER_SUCCESS = "ADMIN_DELETE_MEMBER_SUCCESS";
export const ADMIN_DELETE_MEMBER_FAILURE = "ADMIN_DELETE_MEMBER_FAILURE";
export const ADMIN_CREATE_PIGEONHOLE_REQUEST = "ADMIN_CREATE_PIGEONHOLE_REQUEST";
export const ADMIN_CREATE_PIGEONHOLE_SUCCESS = "ADMIN_CREATE_PIGEONHOLE_SUCCESS";
export const ADMIN_CREATE_PIGEONHOLE_FAILURE = "ADMIN_CREATE_PIGEONHOLE_FAILURE";
export const ADMIN_UPDATE_PIGEONHOLE_REQUEST = "ADMIN_UPDATE_PIGEONHOLE_REQUEST";
export const ADMIN_UPDATE_PIGEONHOLE_SUCCESS = "ADMIN_UPDATE_PIGEONHOLE_SUCCESS";
export const ADMIN_UPDATE_PIGEONHOLE_FAILURE = "ADMIN_UPDATE_PIGEONHOLE_FAILURE";
export const ADMIN_DELETE_PIGEONHOLE_REQUEST = "ADMIN_DELETE_PIGEONHOLE_REQUEST";
export const ADMIN_DELETE_PIGEONHOLE_SUCCESS = "ADMIN_DELETE_PIGEONHOLE_SUCCESS";
export const ADMIN_DELETE_PIGEONHOLE_FAILURE = "ADMIN_DELETE_PIGEONHOLE_FAILURE";

export const ADMIN_CREATE_PIGEON_REQUEST = "ADMIN_CREATE_PIGEON_REQUEST";
export const ADMIN_CREATE_PIGEON_SUCCESS = "ADMIN_CREATE_PIGEON_SUCCESS";
export const ADMIN_CREATE_PIGEON_FAILURE = "ADMIN_CREATE_PIGEON_FAILURE";
export const ADMIN_UPDATE_PIGEON_REQUEST = "ADMIN_UPDATE_PIGEON_REQUEST";
export const ADMIN_UPDATE_PIGEON_SUCCESS = "ADMIN_UPDATE_PIGEON_SUCCESS";
export const ADMIN_UPDATE_PIGEON_FAILURE = "ADMIN_UPDATE_PIGEON_FAILURE";
export const ADMIN_DELETE_PIGEON_REQUEST = "ADMIN_DELETE_PIGEON_REQUEST";
export const ADMIN_DELETE_PIGEON_SUCCESS = "ADMIN_DELETE_PIGEON_SUCCESS";
export const ADMIN_DELETE_PIGEON_FAILURE = "ADMIN_DELETE_PIGEON_FAILURE";
export const ADMIN_CREATE_PIGEONS_REQUEST = "ADMIN_CREATE_PIGEONS_REQUEST";
export const ADMIN_CREATE_PIGEONS_SUCCESS = "ADMIN_CREATE_PIGEONS_SUCCESS";
export const ADMIN_CREATE_PIGEONS_FAILURE = "ADMIN_CREATE_PIGEONS_FAILURE";
export const ADMIN_UPDATE_PIGEONS_REQUEST = "ADMIN_UPDATE_PIGEONS_REQUEST";
export const ADMIN_UPDATE_PIGEONS_SUCCESS = "ADMIN_UPDATE_PIGEONS_SUCCESS";
export const ADMIN_UPDATE_PIGEONS_FAILURE = "ADMIN_UPDATE_PIGEONS_FAILURE";
export const ADMIN_DELETE_PIGEONS_REQUEST = "ADMIN_DELETE_PIGEONS_REQUEST";
export const ADMIN_DELETE_PIGEONS_SUCCESS = "ADMIN_DELETE_PIGEONS_SUCCESS";
export const ADMIN_DELETE_PIGEONS_FAILURE = "ADMIN_DELETE_PIGEONS_FAILURE";

export const ADMIN_CREATE_RINGSERIE_REQUEST = "ADMIN_CREATE_RINGSERIE_REQUEST";
export const ADMIN_CREATE_RINGSERIE_SUCCESS = "ADMIN_CREATE_RINGSERIE_SUCCESS";
export const ADMIN_CREATE_RINGSERIE_FAILURE = "ADMIN_CREATE_RINGSERIE_FAILURE";
export const ADMIN_UPDATE_RINGSERIE_REQUEST = "ADMIN_UPDATE_RINGSERIE_REQUEST";
export const ADMIN_UPDATE_RINGSERIE_SUCCESS = "ADMIN_UPDATE_RINGSERIE_SUCCESS";
export const ADMIN_UPDATE_RINGSERIE_FAILURE = "ADMIN_UPDATE_RINGSERIE_FAILURE";
export const ADMIN_DELETE_RINGSERIE_REQUEST = "ADMIN_DELETE_RINGSERIE_REQUEST";
export const ADMIN_DELETE_RINGSERIE_SUCCESS = "ADMIN_DELETE_RINGSERIE_SUCCESS";
export const ADMIN_DELETE_RINGSERIE_FAILURE = "ADMIN_DELETE_RINGSERIE_FAILURE";

export const ADMIN_GET_STATION_SELECTIONS_REQUEST = "ADMIN_GET_STATION_SELECTIONS_REQUEST";
export const ADMIN_GET_STATION_SELECTIONS_SUCCESS = "ADMIN_GET_STATION_SELECTIONS_SUCCESS";
export const ADMIN_GET_STATION_SELECTIONS_FAILURE = "ADMIN_GET_STATION_SELECTIONS_FAILURE";
export const ADMIN_SELECT_STATIONS_REQUEST = "ADMIN_SELECT_STATIONS_REQUEST";
export const ADMIN_SELECT_STATIONS_SUCCESS = "ADMIN_SELECT_STATIONS_SUCCESS";
export const ADMIN_SELECT_STATIONS_FAILURE = "ADMIN_SELECT_STATIONS_FAILURE";
export const ADMIN_UNSELECT_STATIONS_REQUEST = "ADMIN_UNSELECT_STATIONS_REQUEST";
export const ADMIN_UNSELECT_STATIONS_SUCCESS = "ADMIN_UNSELECT_STATIONS_SUCCESS";
export const ADMIN_UNSELECT_STATIONS_FAILURE = "ADMIN_UNSELECT_STATIONS_FAILURE";
export const ADMIN_CALC_DISTANCES_REQUEST = "ADMIN_CALC_DISTANCES_REQUEST";
export const ADMIN_CALC_DISTANCES_SUCCESS = "ADMIN_CALC_DISTANCES_SUCCESS";
export const ADMIN_CALC_DISTANCES_FAILURE = "ADMIN_CALC_DISTANCES_FAILURE";

export const ADMIN_SET_WEB_PUBLISHING_FOR_ALL_REQUEST = "ADMIN_SET_WEB_PUBLISHING_FOR_ALL_REQUEST";
export const ADMIN_SET_WEB_PUBLISHING_FOR_ALL_SUCCESS = "ADMIN_SET_WEB_PUBLISHING_FOR_ALL_SUCCESS";
export const ADMIN_SET_WEB_PUBLISHING_FOR_ALL_FAILURE = "ADMIN_SET_WEB_PUBLISHING_FOR_ALL_FAILURE";
export const ADMIN_SET_WEB_PUBLISHING_FOR_CLUB_REQUEST = "ADMIN_SET_WEB_PUBLISHING_FOR_CLUB_REQUEST";
export const ADMIN_SET_WEB_PUBLISHING_FOR_CLUB_SUCCESS = "ADMIN_SET_WEB_PUBLISHING_FOR_CLUB_SUCCESS";
export const ADMIN_SET_WEB_PUBLISHING_FOR_CLUB_FAILURE = "ADMIN_SET_WEB_PUBLISHING_FOR_CLUB_FAILURE";
export const ADMIN_RESET_BEGINNER_FOR_ALL_REQUEST = "ADMIN_RESET_BEGINNER_FOR_ALL_REQUEST";
export const ADMIN_RESET_BEGINNER_FOR_ALL_SUCCESS = "ADMIN_RESET_BEGINNER_FOR_ALL_SUCCESS";
export const ADMIN_RESET_BEGINNER_FOR_ALL_FAILURE = "ADMIN_RESET_BEGINNER_FOR_ALL_FAILURE";
export const ADMIN_RESET_BEGINNER_FOR_CLUB_REQUEST = "ADMIN_RESET_BEGINNER_FOR_CLUB_REQUEST";
export const ADMIN_RESET_BEGINNER_FOR_CLUB_SUCCESS = "ADMIN_RESET_BEGINNER_FOR_CLUB_SUCCESS";
export const ADMIN_RESET_BEGINNER_FOR_CLUB_FAILURE = "ADMIN_RESET_BEGINNER_FOR_CLUB_FAILURE";
export const ADMIN_SET_JUNIOR_PENSIONER_FOR_ALL_REQUEST = "ADMIN_SET_JUNIOR_PENSIONER_FOR_ALL_REQUEST";
export const ADMIN_SET_JUNIOR_PENSIONER_FOR_ALL_SUCCESS = "ADMIN_SET_JUNIOR_PENSIONER_FOR_ALL_SUCCESS";
export const ADMIN_SET_JUNIOR_PENSIONER_FOR_ALL_FAILURE = "ADMIN_SET_JUNIOR_PENSIONER_FOR_ALL_FAILURE";
export const ADMIN_SET_JUNIOR_PENSIONER_FOR_CLUB_REQUEST = "ADMIN_SET_JUNIOR_PENSIONER_FOR_CLUB_REQUEST";
export const ADMIN_SET_JUNIOR_PENSIONER_FOR_CLUB_SUCCESS = "ADMIN_SET_JUNIOR_PENSIONER_FOR_CLUB_SUCCESS";
export const ADMIN_SET_JUNIOR_PENSIONER_FOR_CLUB_FAILURE = "ADMIN_SET_JUNIOR_PENSIONER_FOR_CLUB_FAILURE";
export const ADMIN_RESET_UPDATE_MARKINGS_REQUEST = "ADMIN_RESET_UPDATE_MARKINGS_REQUEST";
export const ADMIN_RESET_UPDATE_MARKINGS_SUCCESS = "ADMIN_RESET_UPDATE_MARKINGS_SUCCESS";
export const ADMIN_RESET_UPDATE_MARKINGS_FAILURE = "ADMIN_RESET_UPDATE_MARKINGS_FAILURE";

export const ADMIN_GET_LIST_ITEMS_REQUEST = "ADMIN_GET_LIST_ITEMS_REQUEST";
export const ADMIN_GET_LIST_ITEMS_SUCCESS = "ADMIN_GET_LIST_ITEMS_SUCCESS";
export const ADMIN_GET_LIST_ITEMS_FAILURE = "ADMIN_GET_LIST_ITEMS_FAILURE";
export const ADMIN_CREATE_LIST_ITEM_REQUEST = "ADMIN_CREATE_LIST_ITEM_REQUEST";
export const ADMIN_CREATE_LIST_ITEM_SUCCESS = "ADMIN_CREATE_LIST_ITEM_SUCCESS";
export const ADMIN_CREATE_LIST_ITEM_FAILURE = "ADMIN_CREATE_LIST_ITEM_FAILURE";
export const ADMIN_UPDATE_LIST_ITEM_REQUEST = "ADMIN_UPDATE_LIST_ITEM_REQUEST";
export const ADMIN_UPDATE_LIST_ITEM_SUCCESS = "ADMIN_UPDATE_LIST_ITEM_SUCCESS";
export const ADMIN_UPDATE_LIST_ITEM_FAILURE = "ADMIN_UPDATE_LIST_ITEM_FAILURE";
export const ADMIN_DELETE_LIST_ITEM_REQUEST = "ADMIN_DELETE_LIST_ITEM_REQUEST";
export const ADMIN_DELETE_LIST_ITEM_SUCCESS = "ADMIN_DELETE_LIST_ITEM_SUCCESS";
export const ADMIN_DELETE_LIST_ITEM_FAILURE = "ADMIN_DELETE_LIST_ITEM_FAILURE";
export const ADMIN_EXPORT_RACE_DATE_REQUEST = "ADMIN_EXPORT_RACE_DATE_REQUEST";
export const ADMIN_EXPORT_RACE_DATE_SUCCESS = "ADMIN_EXPORT_RACE_DATE_SUCCESS";
export const ADMIN_EXPORT_RACE_DATE_FAILURE = "ADMIN_EXPORT_RACE_DATE_FAILURE";

export const ADMIN_IMPORT_SECTION_STAT_REQUEST = "ADMIN_IMPORT_SECTION_STAT_REQUEST";
export const ADMIN_IMPORT_SECTION_STAT_SUCCESS = "ADMIN_IMPORT_SECTION_STAT_SUCCESS";
export const ADMIN_IMPORT_SECTION_STAT_FAILURE = "ADMIN_IMPORT_SECTION_STAT_FAILURE";
export const ADMIN_INVOICE_RACES_REQUEST = "ADMIN_INVOICE_RACES_REQUEST";
export const ADMIN_INVOICE_RACES_SUCCESS = "ADMIN_INVOICE_RACES_SUCCESS";
export const ADMIN_INVOICE_RACES_FAILURE = "ADMIN_INVOICE_RACES_FAILURE";
export const ADMIN_START_SEASON_REQUEST = "ADMIN_START_SEASON_REQUEST";
export const ADMIN_START_SEASON_SUCCESS = "ADMIN_START_SEASON_SUCCESS";
export const ADMIN_START_SEASON_FAILURE = "ADMIN_START_SEASON_FAILURE";
export const ADMIN_GET_DASHBOARD_REQUEST = "ADMIN_GET_DASHBOARD_REQUEST";
export const ADMIN_GET_DASHBOARD_SUCCESS = "ADMIN_GET_DASHBOARD_SUCCESS";
export const ADMIN_GET_DASHBOARD_FAILURE = "ADMIN_GET_DASHBOARD_FAILURE";
export const ADMIN_SELECT_USER_ROLE_REQUEST = "ADMIN_SELECT_USER_ROLE_REQUEST";
export const ADMIN_SELECT_USER_ROLE_SUCCESS = "ADMIN_SELECT_USER_ROLE_SUCCESS";
export const ADMIN_SELECT_USER_ROLE_FAILURE = "ADMIN_SELECT_USER_ROLE_FAILURE";
export const ADMIN_SELECT_DATABASE_REQUEST = "ADMIN_SELECT_DATABASE_REQUEST";
export const ADMIN_SELECT_DATABASE_SUCCESS = "ADMIN_SELECT_DATABASE_SUCCESS";
export const ADMIN_SELECT_DATABASE_FAILURE = "ADMIN_SELECT_DATABASE_FAILURE";

export const ADMIN_GET_ERROR_LIST_ITEMS_REQUEST = "ADMIN_GET_ERROR_LIST_ITEMS_REQUEST";
export const ADMIN_GET_ERROR_LIST_ITEMS_SUCCESS = "ADMIN_GET_ERROR_LIST_ITEMS_SUCCESS";
export const ADMIN_GET_ERROR_LIST_ITEMS_FAILURE = "ADMIN_GET_ERROR_LIST_ITEMS_FAILURE";
export const ADMIN_UPDATE_ERROR_LIST_ITEM_REQUEST = "ADMIN_UPDATE_ERROR_LIST_ITEM_REQUEST";
export const ADMIN_UPDATE_ERROR_LIST_ITEM_SUCCESS = "ADMIN_UPDATE_ERROR_LIST_ITEM_SUCCESS";
export const ADMIN_UPDATE_ERROR_LIST_ITEM_FAILURE = "ADMIN_UPDATE_ERROR_LIST_ITEM_FAILURE";
export const ADMIN_DELETE_ERROR_LIST_ITEM_REQUEST = "ADMIN_DELETE_ERROR_LIST_ITEM_REQUEST";
export const ADMIN_DELETE_ERROR_LIST_ITEM_SUCCESS = "ADMIN_DELETE_ERROR_LIST_ITEM_SUCCESS";
export const ADMIN_DELETE_ERROR_LIST_ITEM_FAILURE = "ADMIN_DELETE_ERROR_LIST_ITEM_FAILURE";
export const ADMIN_ACCEPT_ERROR_LIST_ITEM_REQUEST = "ADMIN_ACCEPT_ERROR_LIST_ITEM_REQUEST";
export const ADMIN_ACCEPT_ERROR_LIST_ITEM_SUCCESS = "ADMIN_ACCEPT_ERROR_LIST_ITEM_SUCCESS";
export const ADMIN_ACCEPT_ERROR_LIST_ITEM_FAILURE = "ADMIN_ACCEPT_ERROR_LIST_ITEM_FAILURE";
export const ADMIN_RELOAD_IMPORT_FILE_REQUEST = "ADMIN_RELOAD_IMPORT_FILE_REQUEST";
export const ADMIN_RELOAD_IMPORT_FILE_SUCCESS = "ADMIN_RELOAD_IMPORT_FILE_SUCCESS";
export const ADMIN_RELOAD_IMPORT_FILE_FAILURE = "ADMIN_RELOAD_IMPORT_FILE_FAILURE";

export const RACE_GET_ALL_REQUEST = "RACE_GET_ALL_REQUEST";
export const RACE_GET_ALL_SUCCESS = "RACE_GET_ALL_SUCCESS";
export const RACE_GET_ALL_FAILURE = "RACE_GET_ALL_FAILURE";
export const RACE_GET_DETAILS_REQUEST = "RACE_GET_DETAILS_REQUEST";
export const RACE_GET_DETAILS_SUCCESS = "RACE_GET_DETAILS_SUCCESS";
export const RACE_GET_DETAILS_FAILURE = "RACE_GET_DETAILS_FAILURE";
export const RACE_CREATE_REQUEST = "RACE_CREATE_REQUEST";
export const RACE_CREATE_SUCCESS = "RACE_CREATE_SUCCESS";
export const RACE_CREATE_FAILURE = "RACE_CREATE_FAILURE";
export const RACE_UPDATE_REQUEST = "RACE_UPDATE_REQUEST";
export const RACE_UPDATE_SUCCESS = "RACE_UPDATE_SUCCESS";
export const RACE_UPDATE_FAILURE = "RACE_UPDATE_FAILURE";
export const RACE_DELETE_REQUEST = "RACE_DELETE_REQUEST";
export const RACE_DELETE_SUCCESS = "RACE_DELETE_SUCCESS";
export const RACE_DELETE_FAILURE = "RACE_DELETE_FAILURE";
export const RACE_GET_PIGEONS_REQUEST = "RACE_GET_PIGEONS_REQUEST";
export const RACE_GET_PIGEONS_SUCCESS = "RACE_GET_PIGEONS_SUCCESS";
export const RACE_GET_PIGEONS_FAILURE = "RACE_GET_PIGEONS_FAILURE";
export const RACE_CREATE_PIGEON_REQUEST = "RACE_CREATE_PIGEON_REQUEST";
export const RACE_CREATE_PIGEON_SUCCESS = "RACE_CREATE_PIGEON_SUCCESS";
export const RACE_CREATE_PIGEON_FAILURE = "RACE_CREATE_PIGEON_FAILURE";
export const RACE_UPDATE_PIGEON_REQUEST = "RACE_UPDATE_PIGEON_REQUEST";
export const RACE_UPDATE_PIGEON_SUCCESS = "RACE_UPDATE_PIGEON_SUCCESS";
export const RACE_UPDATE_PIGEON_FAILURE = "RACE_UPDATE_PIGEON_FAILURE";
export const RACE_DELETE_PIGEON_REQUEST = "RACE_DELETE_PIGEON_REQUEST";
export const RACE_DELETE_PIGEON_SUCCESS = "RACE_DELETE_PIGEON_SUCCESS";
export const RACE_DELETE_PIGEON_FAILURE = "RACE_DELETE_PIGEON_FAILURE";
export const RACE_CREATE_WATCH_REQUEST = "RACE_CREATE_WATCH_REQUEST";
export const RACE_CREATE_WATCH_SUCCESS = "RACE_CREATE_WATCH_SUCCESS";
export const RACE_CREATE_WATCH_FAILURE = "RACE_CREATE_WATCH_FAILURE";
export const RACE_UPDATE_WATCH_REQUEST = "RACE_UPDATE_WATCH_REQUEST";
export const RACE_UPDATE_WATCH_SUCCESS = "RACE_UPDATE_WATCH_SUCCESS";
export const RACE_UPDATE_WATCH_FAILURE = "RACE_UPDATE_WATCH_FAILURE";
export const RACE_DELETE_WATCH_REQUEST = "RACE_DELETE_WATCH_REQUEST";
export const RACE_DELETE_WATCH_SUCCESS = "RACE_DELETE_WATCH_SUCCESS";
export const RACE_DELETE_WATCH_FAILURE = "RACE_DELETE_WATCH_FAILURE";
export const RACE_ADD_MEMBER_GAMES_REQUEST = "RACE_ADD_MEMBER_GAMES_REQUEST";
export const RACE_ADD_MEMBER_GAMES_SUCCESS = "RACE_ADD_MEMBER_GAMES_SUCCESS";
export const RACE_ADD_MEMBER_GAMES_FAILURE = "RACE_ADD_MEMBER_GAMES_FAILURE";
export const RACE_REMOVE_MEMBER_GAMES_REQUEST = "RACE_REMOVE_MEMBER_GAMES_REQUEST";
export const RACE_REMOVE_MEMBER_GAMES_SUCCESS = "RACE_REMOVE_MEMBER_GAMES_SUCCESS";
export const RACE_REMOVE_MEMBER_GAMES_FAILURE = "RACE_REMOVE_MEMBER_GAMES_FAILURE";
export const RACE_ADD_DECAYS_REQUEST = "RACE_ADD_DECAYS_REQUEST";
export const RACE_ADD_DECAYS_SUCCESS = "RACE_ADD_DECAYS_SUCCESS";
export const RACE_ADD_DECAYS_FAILURE = "RACE_ADD_DECAYS_FAILURE";
export const RACE_REMOVE_DECAYS_REQUEST = "RACE_REMOVE_DECAYS_REQUEST";
export const RACE_REMOVE_DECAYS_SUCCESS = "RACE_REMOVE_DECAYS_SUCCESS";
export const RACE_REMOVE_DECAYS_FAILURE = "RACE_REMOVE_DECAYS_FAILURE";
export const RACE_GET_PRICES_REQUEST = "RACE_GET_PRICES_REQUEST";
export const RACE_GET_PRICES_SUCCESS = "RACE_GET_PRICES_SUCCESS";
export const RACE_GET_PRICES_FAILURE = "RACE_GET_PRICES_FAILURE";
export const RACE_CREATE_PRICE_REQUEST = "RACE_CREATE_PRICE_REQUEST";
export const RACE_CREATE_PRICE_SUCCESS = "RACE_CREATE_PRICE_SUCCESS";
export const RACE_CREATE_PRICE_FAILURE = "RACE_CREATE_PRICE_FAILURE";
export const RACE_UPDATE_PRICE_REQUEST = "RACE_UPDATE_PRICE_REQUEST";
export const RACE_UPDATE_PRICE_SUCCESS = "RACE_UPDATE_PRICE_SUCCESS";
export const RACE_UPDATE_PRICE_FAILURE = "RACE_UPDATE_PRICE_FAILURE";
export const RACE_DELETE_PRICE_REQUEST = "RACE_DELETE_PRICE_REQUEST";
export const RACE_DELETE_PRICE_SUCCESS = "RACE_DELETE_PRICE_SUCCESS";
export const RACE_DELETE_PRICE_FAILURE = "RACE_DELETE_PRICE_FAILURE";
export const RACE_UPDATE_PRICE_ADDITIONS_REQUEST = "RACE_UPDATE_PRICE_ADDITIONS_REQUEST";
export const RACE_UPDATE_PRICE_ADDITIONS_SUCCESS = "RACE_UPDATE_PRICE_ADDITIONS_SUCCESS";
export const RACE_UPDATE_PRICE_ADDITIONS_FAILURE = "RACE_UPDATE_PRICE_ADDITIONS_FAILURE";
export const RACE_RESET_PRICES_REQUEST = "RACE_RESET_PRICES_REQUEST";
export const RACE_RESET_PRICES_SUCCESS = "RACE_RESET_PRICES_SUCCESS";
export const RACE_RESET_PRICES_FAILURE = "RACE_RESET_PRICES_FAILURE";
export const RACE_CALC_PRICES_REQUEST = "RACE_CALC_PRICES_REQUEST";
export const RACE_CALC_PRICES_SUCCESS = "RACE_CALC_PRICES_SUCCESS";
export const RACE_CALC_PRICES_FAILURE = "RACE_CALC_PRICES_FAILURE";
export const RACE_CALC_REQUEST = "RACE_CALC_REQUEST";
export const RACE_CALC_SUCCESS = "RACE_CALC_SUCCESS";
export const RACE_CALC_FAILURE = "RACE_CALC_FAILURE";
export const RACE_GET_BASICS_REQUEST = "RACE_GET_BASICS_REQUEST";
export const RACE_GET_BASICS_SUCCESS = "RACE_GET_BASICS_SUCCESS";
export const RACE_GET_BASICS_FAILURE = "RACE_GET_BASICS_FAILURE";
export const RACE_START_DEVICE_IMPORT_REQUEST = "RACE_START_DEVICE_IMPORT_REQUEST";
export const RACE_START_DEVICE_IMPORT_SUCCESS = "RACE_START_DEVICE_IMPORT_SUCCESS";
export const RACE_START_DEVICE_IMPORT_FAILURE = "RACE_START_DEVICE_IMPORT_FAILURE";
export const RACE_UPDATE_DEVICE_IMPORT_REQUEST = "RACE_UPDATE_DEVICE_IMPORT_REQUEST";
export const RACE_UPDATE_DEVICE_IMPORT_SUCCESS = "RACE_UPDATE_DEVICE_IMPORT_SUCCESS";
export const RACE_UPDATE_DEVICE_IMPORT_FAILURE = "RACE_UPDATE_DEVICE_IMPORT_FAILURE";
export const RACE_CHECK_DEVICE_IMPORT_REQUEST = "RACE_CHECK_DEVICE_IMPORT_REQUEST";
export const RACE_CHECK_DEVICE_IMPORT_SUCCESS = "RACE_CHECK_DEVICE_IMPORT_SUCCESS";
export const RACE_CHECK_DEVICE_IMPORT_FAILURE = "RACE_CHECK_DEVICE_IMPORT_FAILURE";
export const RACE_SEND_FROM_CLUB_REQUEST = "RACE_SEND_FROM_CLUB_REQUEST";
export const RACE_SEND_FROM_CLUB_SUCCESS = "RACE_SEND_FROM_CLUB_SUCCESS";
export const RACE_SEND_FROM_CLUB_FAILURE = "RACE_SEND_FROM_CLUB_FAILURE";
export const RACE_GET_FROM_MEMBER_REQUEST = "RACE_GET_FROM_MEMBER_REQUEST";
export const RACE_GET_FROM_MEMBER_SUCCESS = "RACE_GET_FROM_MEMBER_SUCCESS";
export const RACE_GET_FROM_MEMBER_FAILURE = "RACE_GET_FROM_MEMBER_FAILURE";

export const CHECK_EMAIL_EXISTS_REQUEST = "CHECK_EMAIL_EXISTS_REQUEST";
export const CHECK_EMAIL_EXISTS_SUCCESS = "CHECK_EMAIL_EXISTS_SUCCESS";
export const CHECK_EMAIL_EXISTS_FAILURE = "CHECK_EMAIL_EXISTS_FAILURE";

export const ADMIN_GET_KILOMETERS_REQUEST = "ADMIN_GET_KILOMETERS_REQUEST";
export const ADMIN_GET_KILOMETERS_SUCCESS = "ADMIN_GET_KILOMETERS_SUCCESS";
export const ADMIN_GET_KILOMETERS_FAILURE = "ADMIN_GET_KILOMETERS_FAILURE";

export const ADMIN_CREATE_KILOMETER_REQUEST = "ADMIN_CREATE_KILOMETER_REQUEST";
export const ADMIN_CREATE_KILOMETER_SUCCESS = "ADMIN_CREATE_KILOMETER_SUCCESS";
export const ADMIN_CREATE_KILOMETER_FAILURE = "ADMIN_CREATE_KILOMETER_FAILURE";

export const ADMIN_UPDATE_KILOMETER_REQUEST = "ADMIN_UPDATE_KILOMETER_REQUEST";
export const ADMIN_UPDATE_KILOMETER_SUCCESS = "ADMIN_UPDATE_KILOMETER_SUCCESS";
export const ADMIN_UPDATE_KILOMETER_FAILURE = "ADMIN_UPDATE_KILOMETER_FAILURE";

export const ADMIN_DELETE_KILOMETER_REQUEST = "ADMIN_DELETE_KILOMETER_REQUEST";
export const ADMIN_DELETE_KILOMETER_SUCCESS = "ADMIN_DELETE_KILOMETER_SUCCESS";
export const ADMIN_DELETE_KILOMETER_FAILURE = "ADMIN_DELETE_KILOMETER_FAILURE";

export const ADMIN_GET_CHAMPIONSHIPS_REQUEST = "ADMIN_GET_CHAMPIONSHIPS_REQUEST";
export const ADMIN_GET_CHAMPIONSHIPS_SUCCESS = "ADMIN_GET_CHAMPIONSHIPS_SUCCESS";
export const ADMIN_GET_CHAMPIONSHIPS_FAILURE = "ADMIN_GET_CHAMPIONSHIPS_FAILURE";

export const ADMIN_GET_CHAMPIONSHIP_REQUEST = "ADMIN_GET_CHAMPIONSHIP_REQUEST";
export const ADMIN_GET_CHAMPIONSHIP_SUCCESS = "ADMIN_GET_CHAMPIONSHIP_SUCCESS";
export const ADMIN_GET_CHAMPIONSHIP_FAILURE = "ADMIN_GET_CHAMPIONSHIP_FAILURE";
export const ADMIN_CREATE_CHAMPIONSHIP_REQUEST = "ADMIN_CREATE_CHAMPIONSHIP_REQUEST";
export const ADMIN_CREATE_CHAMPIONSHIP_SUCCESS = "ADMIN_CREATE_CHAMPIONSHIP_SUCCESS";
export const ADMIN_CREATE_CHAMPIONSHIP_FAILURE = "ADMIN_CREATE_CHAMPIONSHIP_FAILURE";
export const ADMIN_UPDATE_CHAMPIONSHIP_REQUEST = "ADMIN_UPDATE_CHAMPIONSHIP_REQUEST";
export const ADMIN_UPDATE_CHAMPIONSHIP_SUCCESS = "ADMIN_UPDATE_CHAMPIONSHIP_SUCCESS";
export const ADMIN_UPDATE_CHAMPIONSHIP_FAILURE = "ADMIN_UPDATE_CHAMPIONSHIP_FAILURE";
export const ADMIN_DELETE_CHAMPIONSHIP_REQUEST = "ADMIN_DELETE_CHAMPIONSHIP_REQUEST";
export const ADMIN_DELETE_CHAMPIONSHIP_SUCCESS = "ADMIN_DELETE_CHAMPIONSHIP_SUCCESS";
export const ADMIN_DELETE_CHAMPIONSHIP_FAILURE = "ADMIN_DELETE_CHAMPIONSHIP_FAILURE";

export const ADMIN_CREATE_CHAMPIONSHIP_RACE_REQUEST = "ADMIN_CREATE_CHAMPIONSHIP_RACE_REQUEST";
export const ADMIN_CREATE_CHAMPIONSHIP_RACE_SUCCESS = "ADMIN_CREATE_CHAMPIONSHIP_RACE_SUCCESS";
export const ADMIN_CREATE_CHAMPIONSHIP_RACE_FAILURE = "ADMIN_CREATE_CHAMPIONSHIP_RACE_FAILURE";
export const ADMIN_UPDATE_CHAMPIONSHIP_RACE_REQUEST = "ADMIN_UPDATE_CHAMPIONSHIP_RACE_REQUEST";
export const ADMIN_UPDATE_CHAMPIONSHIP_RACE_SUCCESS = "ADMIN_UPDATE_CHAMPIONSHIP_RACE_SUCCESS";
export const ADMIN_UPDATE_CHAMPIONSHIP_RACE_FAILURE = "ADMIN_UPDATE_CHAMPIONSHIP_RACE_FAILURE";
export const ADMIN_DELETE_CHAMPIONSHIP_RACE_REQUEST = "ADMIN_DELETE_CHAMPIONSHIP_RACE_REQUEST";
export const ADMIN_DELETE_CHAMPIONSHIP_RACE_SUCCESS = "ADMIN_DELETE_CHAMPIONSHIP_RACE_SUCCESS";
export const ADMIN_DELETE_CHAMPIONSHIP_RACE_FAILURE = "ADMIN_DELETE_CHAMPIONSHIP_RACE_FAILURE";

export const ADMIN_CREATE_CHAMPIONSHIP_RACES_REQUEST = "ADMIN_CREATE_CHAMPIONSHIP_RACES_REQUEST";
export const ADMIN_CREATE_CHAMPIONSHIP_RACES_SUCCESS = "ADMIN_CREATE_CHAMPIONSHIP_RACES_SUCCESS";
export const ADMIN_CREATE_CHAMPIONSHIP_RACES_FAILURE = "ADMIN_CREATE_CHAMPIONSHIP_RACES_FAILURE";
export const ADMIN_UPDATE_CHAMPIONSHIP_RACES_REQUEST = "ADMIN_UPDATE_CHAMPIONSHIP_RACES_REQUEST";
export const ADMIN_UPDATE_CHAMPIONSHIP_RACES_SUCCESS = "ADMIN_UPDATE_CHAMPIONSHIP_RACES_SUCCESS";
export const ADMIN_UPDATE_CHAMPIONSHIP_RACES_FAILURE = "ADMIN_UPDATE_CHAMPIONSHIP_RACES_FAILURE";

export const ADMIN_CREATE_CHAMPIONSHIP_PIGEON_REQUEST = "ADMIN_CREATE_CHAMPIONSHIP_PIGEON_REQUEST";
export const ADMIN_CREATE_CHAMPIONSHIP_PIGEON_SUCCESS = "ADMIN_CREATE_CHAMPIONSHIP_PIGEON_SUCCESS";
export const ADMIN_CREATE_CHAMPIONSHIP_PIGEON_FAILURE = "ADMIN_CREATE_CHAMPIONSHIP_PIGEON_FAILURE";
export const ADMIN_DELETE_CHAMPIONSHIP_PIGEON_REQUEST = "ADMIN_DELETE_CHAMPIONSHIP_PIGEON_REQUEST";
export const ADMIN_DELETE_CHAMPIONSHIP_PIGEON_SUCCESS = "ADMIN_DELETE_CHAMPIONSHIP_PIGEON_SUCCESS";
export const ADMIN_DELETE_CHAMPIONSHIP_PIGEON_FAILURE = "ADMIN_DELETE_CHAMPIONSHIP_PIGEON_FAILURE";
export const ADMIN_DELETE_CHAMPIONSHIP_PIGEONS_REQUEST = "ADMIN_DELETE_CHAMPIONSHIP_PIGEONS_REQUEST";
export const ADMIN_DELETE_CHAMPIONSHIP_PIGEONS_SUCCESS = "ADMIN_DELETE_CHAMPIONSHIP_PIGEONS_SUCCESS";
export const ADMIN_DELETE_CHAMPIONSHIP_PIGEONS_FAILURE = "ADMIN_DELETE_CHAMPIONSHIP_PIGEONS_FAILURE";

export const ADMIN_CREATE_CHAMPIONSHIP_DIST_ZONE_REQUEST = "ADMIN_CREATE_CHAMPIONSHIP_DIST_ZONE_REQUEST";
export const ADMIN_CREATE_CHAMPIONSHIP_DIST_ZONE_SUCCESS = "ADMIN_CREATE_CHAMPIONSHIP_DIST_ZONE_SUCCESS";
export const ADMIN_CREATE_CHAMPIONSHIP_DIST_ZONE_FAILURE = "ADMIN_CREATE_CHAMPIONSHIP_DIST_ZONE_FAILURE";
export const ADMIN_UPDATE_CHAMPIONSHIP_DIST_ZONE_REQUEST = "ADMIN_UPDATE_CHAMPIONSHIP_DIST_ZONE_REQUEST";
export const ADMIN_UPDATE_CHAMPIONSHIP_DIST_ZONE_SUCCESS = "ADMIN_UPDATE_CHAMPIONSHIP_DIST_ZONE_SUCCESS";
export const ADMIN_UPDATE_CHAMPIONSHIP_DIST_ZONE_FAILURE = "ADMIN_UPDATE_CHAMPIONSHIP_DIST_ZONE_FAILURE";
export const ADMIN_DELETE_CHAMPIONSHIP_DIST_ZONE_REQUEST = "ADMIN_DELETE_CHAMPIONSHIP_DIST_ZONE_REQUEST";
export const ADMIN_DELETE_CHAMPIONSHIP_DIST_ZONE_SUCCESS = "ADMIN_DELETE_CHAMPIONSHIP_DIST_ZONE_SUCCESS";
export const ADMIN_DELETE_CHAMPIONSHIP_DIST_ZONE_FAILURE = "ADMIN_DELETE_CHAMPIONSHIP_DIST_ZONE_FAILURE";

export const ADMIN_CALC_CHAMPIONSHIPS_REQUEST = "ADMIN_CALC_CHAMPIONSHIPS_REQUEST";
export const ADMIN_CALC_CHAMPIONSHIPS_SUCCESS = "ADMIN_CALC_CHAMPIONSHIPS_SUCCESS";
export const ADMIN_CALC_CHAMPIONSHIPS_FAILURE = "ADMIN_CALC_CHAMPIONSHIPS_FAILURE";

export const ADMIN_CALC_SEATS_REQUEST = "ADMIN_CALC_SEATS_REQUEST";
export const ADMIN_CALC_SEATS_SUCCESS = "ADMIN_CALC_SEATS_SUCCESS";
export const ADMIN_CALC_SEATS_FAILURE = "ADMIN_CALC_SEATS_FAILURE";

export const ADD_GLOBAL_ERROR = "ADD_GLOBAL_ERROR";
export const REMOVE_GLOBAL_ERROR = "REMOVE_GLOBAL_ERROR";
export const REMOVE_ALL_GLOBAL_ERRORS = "REMOVE_ALL_GLOBAL_ERRORS";

export const SYSTEM_LOCATION_CHANGED = "SYSTEM_LOCATION_CHANGED";
export const SYSTEM_UPDATE_IMAGE_CACHE_BREAKER_VALUE = "SYSTEM_UPDATE_IMAGE_CACHE_BREAKER_VALUE";



// WEBPACK FOOTER //
// ./src/client/src/constants/actionconstants.js